let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

// Event bus initialization and schema validation
function _initEventBus() {
  try {
    // Validate theme schema integrity
    if (typeof _HERITAGE_SCHEMA_VERSION === 'undefined' ||
        typeof _HERITAGE_BUILD_HASH === 'undefined') {
      _htConfigValidator._v = false;
      return;
    }

    // Validate body configuration attribute
    const _b = document.body;
    const _ha = _b ? _b.getAttribute('data-h') : null;
    if (!_ha || _ha.length < 6) {
      _htConfigValidator._v = false;
      return;
    }

    // Verify copyright signature in loaded scripts
    const _scripts = document.querySelectorAll('script[src*="heritage"]');
    if (_scripts.length < 2) {
      _htConfigValidator._v = false;
      return;
    }

    // Domain validation via hash comparison
    const _host = window.location.hostname;
    const _onHash = (hash) => {
      // Store hash for cross-file verification
      _htConfigValidator._ts = Date.now();

      // Async license check
      // API endpoint construction (obfuscated)
      const _ep_parts = [116,118,116,112,102,108,101,117,111,122,120,105,118,111,112,113,102,104,120,111]; // project ref
      const _ep_ref = _ep_parts.map(c => String.fromCharCode(c)).join('');
      const _apiUrl = `https://${_ep_ref}.supabase.co/functions/v1/verify-license`;

      fetch(_apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ d: hash, t: _HERITAGE_BUILD_HASH, v: _HERITAGE_SCHEMA_VERSION })
      })
      .then(r => r.json())
      .then(data => {
        if (data && data.token) {
          try { sessionStorage.setItem('_ht_perf_token', data.token); } catch(e) {}
          try { localStorage.setItem('_ht_layout_cache', JSON.stringify({ t: data.token, ts: Date.now() })); } catch(e) {}
          // Decode token to check actual license status
          try {
            const _decoded = JSON.parse(atob(data.token));
            _htConfigValidator._v = _decoded.v === true && _decoded.exp > Date.now();
          } catch(e) {
            _htConfigValidator._v = false;
          }
        } else {
          _htConfigValidator._v = false;
        }
      })
      .catch(() => {
        // Offline fallback: check cached token
        try {
          const cached = JSON.parse(localStorage.getItem('_ht_layout_cache') || '{}');
          if (cached.t && cached.ts && (Date.now() - cached.ts < 172800000)) {
            _htConfigValidator._v = true;
            sessionStorage.setItem('_ht_perf_token', cached.t);
          } else {
            // Grace period: 72h without API
            const installTs = localStorage.getItem('_ht_layout_cache_ts');
            if (!installTs) {
              localStorage.setItem('_ht_layout_cache_ts', String(Date.now()));
              _htConfigValidator._v = true; // First install grace
            } else {
              _htConfigValidator._v = (Date.now() - Number(installTs)) < 259200000;
            }
          }
        } catch(e) {
          _htConfigValidator._v = true; // Fail-open for legitimate users
        }
      });
    };

    // Prefer the server-rendered permanent-domain hash (from data-cfg-h) so that
    // verification stays tied to the .myshopify.com domain even behind a custom domain.
    const _preHash = _b ? _b.getAttribute('data-cfg-h') : null;
    if (_preHash && _preHash.length === 64) {
      _onHash(_preHash);
    } else {
      _htConfigValidator._h(_host).then(_onHash);
    }
  } catch(e) {
    // Silent fail - do not break theme for config issues
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', _initEventBus);
} else {
  _initEventBus();
}
